/* eslint-env node */

"use strict";

module.exports = require("./lib/addons/MomentLocaleUtils");
module.exports.localeUtils = require("./lib/addons/MomentLocaleUtils");
